import EditAdminDialogComponent from "./editAdminDialog.component";

export default function EditAdminDialogContainer({
  open,
  handleClose,
  handleSubmit,
  selected,
}) {
  return (
    <EditAdminDialogComponent
      open={open}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      selected={selected}
    />
  );
}
